import LanguagesTableHelper from './languages-table-helper';


const LanguageHelpers = {
    TableMain : LanguagesTableHelper,
}

export default LanguageHelpers;